import { StandardLayout } from "common/layouts/StandardLayout";
import queryString from "query-string";
import React from "react";
import { Provider } from "react-redux";
import { initStore } from "./redux/initStore";
import { TourismEmbedConfiguratorContainer } from "./TourismEmbedConfigurator";

const store = initStore();

export class TourismEmbedConfiguratorApp extends React.PureComponent {
  render() {
    const params = queryString.parse(this.props.location.search);
    return (
      <Provider store={store}>
        <StandardLayout>
          <TourismEmbedConfiguratorContainer {...params} />
        </StandardLayout>
      </Provider>
    );
  }
}
